import { FormControlLabel, FormControlLabelProps, Radio } from '@mui/material'
import * as React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

type RadioButtonProps = Omit<FormControlLabelProps, 'control'>
export const RadioButton = (props: RadioButtonProps) => (
  <FormControlLabel {...props} control={<Radio checkedIcon={<CheckCircleIcon />} />} />
)
